import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "inventory-template-page" }
const _hoisted_2 = { class: "inventory-template-page__header" }
const _hoisted_3 = { class: "inventory-template-page__title" }
const _hoisted_4 = {
  key: 0,
  class: "inventory-template-page__preview"
}
const _hoisted_5 = { class: "inventory-template-page__preview-title" }
const _hoisted_6 = { class: "inventory-template-page__preview-description" }
const _hoisted_7 = { class: "inventory-template-page__preview-headers" }
const _hoisted_8 = ["onDragstart", "onDragover", "onDrop"]
const _hoisted_9 = {
  key: 0,
  class: "inventory-template-page__preview-tag inventory-template-page__preview-tag--more"
}
const _hoisted_10 = { class: "inventory-template-page__preview-actions" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "inventory-template-page__back-button-wrapper" }
const _hoisted_13 = { class: "inventory-template-page__sections" }
const _hoisted_14 = { class: "inventory-template-page__section" }
const _hoisted_15 = { class: "inventory-template-page__section-title" }
const _hoisted_16 = { class: "inventory-template-page__section-description" }
const _hoisted_17 = { class: "inventory-template-page__checkbox-grid" }
const _hoisted_18 = ["checked", "onChange"]
const _hoisted_19 = { class: "inventory-template-page__section" }
const _hoisted_20 = { class: "inventory-template-page__section-title" }
const _hoisted_21 = {
  key: 0,
  class: "inventory-template-page__tooltip"
}
const _hoisted_22 = { class: "inventory-template-page__section-description" }
const _hoisted_23 = { class: "inventory-template-page__checkbox-grid" }
const _hoisted_24 = ["checked", "onChange"]
const _hoisted_25 = { class: "inventory-template-page__section" }
const _hoisted_26 = { class: "inventory-template-page__section-title" }
const _hoisted_27 = { class: "inventory-template-page__section-description" }
const _hoisted_28 = { class: "inventory-template-page__settings-content" }
const _hoisted_29 = { class: "inventory-template-page__period" }
const _hoisted_30 = { class: "inventory-template-page__period-label" }
const _hoisted_31 = { class: "inventory-template-page__period-inputs" }
const _hoisted_32 = { class: "inventory-template-page__period-item" }
const _hoisted_33 = { class: "inventory-template-page__period-item-label" }
const _hoisted_34 = { class: "inventory-template-page__period-item" }
const _hoisted_35 = { class: "inventory-template-page__period-item-label" }
const _hoisted_36 = { class: "inventory-template-page__format" }
const _hoisted_37 = { class: "inventory-template-page__format-label" }
const _hoisted_38 = { class: "inventory-template-page__format-options" }
const _hoisted_39 = ["checked"]
const _hoisted_40 = { class: "inventory-template-page__radio-content" }
const _hoisted_41 = { class: "inventory-template-page__radio-label" }
const _hoisted_42 = { class: "inventory-template-page__radio-example" }
const _hoisted_43 = ["checked"]
const _hoisted_44 = { class: "inventory-template-page__radio-content" }
const _hoisted_45 = { class: "inventory-template-page__radio-label" }
const _hoisted_46 = { class: "inventory-template-page__radio-example" }

import MonthPicker from '@/corePagesModule/components/MonthPicker.vue';
import TextButton from '@/components/input/Btn/TextButton.vue';
import SvgLoader from '@/utils/SvgLoader.vue';
import { i18n } from '@/i18n';
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { IYearMonth } from '@/coreDomainsModule/date';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { useRouter } from 'vue-router';

// Composables
import { useTemplateSelectableItems } from '../composables/useTemplateSelectableItems';
import { useTemplateDragDropReorder } from '../composables/useTemplateDragDropReorder';
import { useTemplatePreviewHeaders } from '../composables/useTemplatePreviewHeaders';

// Types and Constants
import { OutputFormat, IMasterItem, IOutputDataItem, PreviewHeaderType } from '../domains/entities/InventoryTemplate';
import {
  getInitialMasterItems,
  getInitialOutputDataItems,
  MAX_PREVIEW_HEADERS,
  isSingleFieldOutputKey,
} from '../constants/inventoryTemplateConstants';

// Template functions
import {
  exportInventoryExcel,
  downloadExcelFromUrl,
  ExportInventoryExcelParams,
  getTemplateFilterState,
  clearTemplateFilterState,
} from './useInventoryStore/inventoryTemplate';
import { toast } from '@/corePagesModule/components/Toast/ToastManager';
import axios from 'axios';


export default /*@__PURE__*/_defineComponent({
  __name: 'InventoryTemplatePage',
  setup(__props) {

const t = i18n.t;
const router = useRouter();

/**
 * プレビューヘッダーのラベルを取得（i18n対応）
 * @param header - プレビューヘッダー
 * @returns 翻訳されたラベル
 */
const getHeaderLabel = (header: {
  type: string;
  masterKey?: string;
  outputDataKey?: string;
  yearMonth?: { year: number; month: number };
}): string => {
  if (header.type === 'master' && header.masterKey) {
    return t(header.masterKey);
  }
  if (header.type === 'outputData' && header.outputDataKey) {
    if (header.yearMonth) {
      return `${t('displayYearMonth', { year: header.yearMonth.year, month: header.yearMonth.month })}_${t(header.outputDataKey)}`;
    }
    return t(header.outputDataKey);
  }
  return '';
};

// Master Items - using composable
const {
  items: masterItems,
  selectedItems: selectedMasterItems,
  handleItemChange: handleMasterItemChange,
  reorderItems: reorderMasterItems,
} = useTemplateSelectableItems<IMasterItem>(getInitialMasterItems());

// Output Data Items - using composable
const {
  items: outputDataItems,
  selectedItems: selectedOutputDataItems,
  handleItemChange: handleOutputDataItemChange,
  reorderItems: reorderOutputDataItems,
  moveSingleFieldItem: moveOutputDataSingleFieldItem,
} = useTemplateSelectableItems<IOutputDataItem>(getInitialOutputDataItems());

// Output Settings
const currentYearMonth = DateService.convertDateToIYearMonth(new Date());
const startYearMonth = ref<IYearMonth>(currentYearMonth);
const endYearMonth = ref<IYearMonth>(DateService.getShiftedIYearMonthByMonths(currentYearMonth.year, currentYearMonth.month, 3));
const outputFormat = ref<OutputFormat>(OutputFormat.BY_MONTH);

const locale = computed(() => i18n.locale);

// Preview Headers - using composable
const { previewHeaders, showPreview, otherColumnsCount } = useTemplatePreviewHeaders(
  selectedMasterItems,
  selectedOutputDataItems,
  startYearMonth,
  endYearMonth,
  outputFormat
);

// Drag and Drop - using composable
const { draggedHeaderId, dragOverIndex, handleDragStart, handleDragEnd, handleDragOver, handleDrop } = useTemplateDragDropReorder();

/**
 * ドロップハンドラーのラッパー
 * @param event - ドラッグイベント
 * @param targetIndex - ターゲットインデックス
 */
const onDrop = (event: DragEvent, targetIndex: number) => {
  handleDrop(event, targetIndex, previewHeaders.value, reorderMasterItems, reorderOutputDataItems, moveOutputDataSingleFieldItem);
};

// Tooltip State for NX Explanation
const showTooltip = ref(false);
const tooltipRef = ref<HTMLElement | null>(null);

/**
 * ツールチップの表示切り替え
 */
const toggleTooltip = () => {
  showTooltip.value = !showTooltip.value;
};

/**
 * ツールチップを非表示にする（外部クリック検出用）
 * @param event - マウスイベント
 */
const handleClickOutside = (event: MouseEvent) => {
  if (tooltipRef.value && event.target && !tooltipRef.value.contains(event.target as Node)) {
    showTooltip.value = false;
  }
};

/**
 * ダウンロードボタンの有効性判定
 */
const isDownloadEnabled = computed(() => {
  const hasMasterItem = selectedMasterItems.value.length > 0;
  const hasOutputData = selectedOutputDataItems.value.length > 0;
  const hasPeriod = startYearMonth.value && endYearMonth.value;
  const hasFormat = outputFormat.value !== null;

  return hasMasterItem && hasOutputData && hasPeriod && hasFormat;
});

/**
 * 単一フィールド項目の挿入位置を計算
 * プレビューヘッダーから単一フィールド項目の位置を取得し、
 * 月別ヘッダー配列内でのインデックスとして返す
 */
const singleFieldPositions = computed<{ [key: string]: number } | undefined>(() => {
  // 出力データ項目のみを抽出（マスタ項目を除く）
  const outputHeaders = previewHeaders.value.filter((h) => h.type === PreviewHeaderType.OUTPUT_DATA);

  // 単一フィールド項目の位置を計算
  const positions: { [key: string]: number } = {};

  outputHeaders.forEach((header, idx) => {
    if (isSingleFieldOutputKey(header.outputDataKey)) {
      // この単一フィールド項目より前にある月別ヘッダーの数がインデックス
      const monthlyHeadersBefore = outputHeaders.slice(0, idx).filter((h) => !isSingleFieldOutputKey(h.outputDataKey)).length;
      positions[header.outputDataKey!] = monthlyHeadersBefore;
    }
  });

  return Object.keys(positions).length > 0 ? positions : undefined;
});

/**
 * 戻るボタンのハンドラー
 */
const handleBack = () => {
  router.back();
};

// Loading state
const isDownloading = ref(false);

/**
 * エラーの種類を判定してユーザーフレンドリーなメッセージを表示
 * @param error - エラーオブジェクト
 */
const handleExportError = (error: unknown) => {
  // Axiosタイムアウトエラーの判定
  if (axios.isAxiosError(error)) {
    if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
      toast.error(t('データ量が多いため処理がタイムアウトしました。出力期間を短くするか、項目数を減らしてください。'));
      return;
    }
    // ネットワークエラー（接続なし）
    if (error.code === 'ERR_NETWORK' || !error.response) {
      toast.error(t('ネットワークエラーが発生しました。接続を確認してください。'));
      return;
    }
    // サーバーエラー (5xx)
    if (error.response && error.response.status >= 500) {
      toast.error(t('サーバーエラーが発生しました。しばらく待ってから再度お試しください。'));
      return;
    }
  }
  // その他のエラー
  toast.error(t('Excelエクスポートに失敗しました'));
};

/**
 * Excelダウンロードボタンのハンドラー
 */
const handleDownload = async () => {
  if (!isDownloadEnabled.value || isDownloading.value) return;

  isDownloading.value = true;

  try {
    // Build params for inventoryTemplate
    const params: ExportInventoryExcelParams = {
      masterItems: selectedMasterItems.value.map((item) => item.key),
      outputDataItems: selectedOutputDataItems.value.map((item) => item.key),
      startYearMonth: startYearMonth.value,
      endYearMonth: endYearMonth.value,
      outputFormat: outputFormat.value,
      singleFieldPositions: singleFieldPositions.value,
      language: locale.value === 'en' ? 'en' : 'ja',
      filterItems: getTemplateFilterState().filterItems,
    };

    const result = await exportInventoryExcel(params);

    if (result.status.type === 'success') {
      const { download_url, file_name } = result.status.data;
      downloadExcelFromUrl(download_url, file_name);
    } else {
      // API returned error response
      const error = result.status.error;
      if (error.statusCode === 504 || error.statusCode === 408) {
        toast.error(t('データ量が多いため処理がタイムアウトしました。出力期間を短くするか、項目数を減らしてください。'));
      } else if (error.statusCode >= 500) {
        toast.error(t('サーバーエラーが発生しました。しばらく待ってから再度お試しください。'));
      } else {
        toast.error(t('Excelエクスポートに失敗しました'));
      }
      console.error('Export failed:', error);
    }
  } catch (error) {
    console.error('Export error:', error);
    handleExportError(error);
  } finally {
    isDownloading.value = false;
  }
};

onMounted(() => {
  document.addEventListener('click', handleClickOutside);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside);
  // フィルター情報をクリア
  clearTemplateFilterState();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(t)('データ出力')), 1)
    ]),
    (_unref(showPreview))
      ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_unref(t)('出力プレビュー')), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(t)('出力ヘッダーの並びを表示しています。')), 1),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(previewHeaders).slice(0, _unref(MAX_PREVIEW_HEADERS)), (header, index) => {
              return (_openBlock(), _createElementBlock("span", {
                key: header.id,
                class: _normalizeClass(["inventory-template-page__preview-tag", {
            'inventory-template-page__preview-tag--dragging': _unref(draggedHeaderId) === header.id,
            'inventory-template-page__preview-tag--drag-over': _unref(dragOverIndex) === index,
          }]),
                draggable: true,
                onDragstart: ($event: any) => (_unref(handleDragStart)($event, header)),
                onDragend: _cache[0] || (_cache[0] = ($event: any) => (_unref(handleDragEnd)($event))),
                onDragover: _withModifiers(($event: any) => (_unref(handleDragOver)($event, index)), ["prevent"]),
                onDrop: ($event: any) => (onDrop($event, index))
              }, _toDisplayString(getHeaderLabel(header)), 43, _hoisted_8))
            }), 128)),
            (_unref(otherColumnsCount) > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, " ..." + _toDisplayString(_unref(t)('他{count}列', { count: _unref(otherColumnsCount) })), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              class: _normalizeClass(["inventory-template-page__download-button", {
            'inventory-template-page__download-button--disabled': !isDownloadEnabled.value || isDownloading.value,
            'inventory-template-page__download-button--loading': isDownloading.value,
          }]),
              disabled: !isDownloadEnabled.value || isDownloading.value,
              onClick: handleDownload
            }, [
              _createTextVNode(_toDisplayString(isDownloading.value ? _unref(t)('ダウンロード中...') : _unref(t)('Excelをダウンロード')) + " ", 1),
              (!isDownloading.value)
                ? (_openBlock(), _createBlock(SvgLoader, {
                    key: 0,
                    name: "downloadSmall",
                    width: "16",
                    height: "16"
                  }))
                : _createCommentVNode("", true)
            ], 10, _hoisted_11),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(TextButton, {
                "button-style": 'btn-secondary',
                size: 'btn-md',
                "on-click": handleBack
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('戻る')), 1)
                ], undefined, true),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("section", _hoisted_14, [
        _createElementVNode("h3", _hoisted_15, _toDisplayString(_unref(t)('マスタ項目')), 1),
        _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(t)('出力する項目を選択してください')), 1),
        _createElementVNode("div", _hoisted_17, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(masterItems), (item) => {
            return (_openBlock(), _createElementBlock("label", {
              key: item.key,
              class: "inventory-template-page__checkbox-item"
            }, [
              _createElementVNode("input", {
                type: "checkbox",
                checked: item.checked,
                onChange: ($event: any) => (_unref(handleMasterItemChange)(item, ($event.target as HTMLInputElement).checked))
              }, null, 40, _hoisted_18),
              _createElementVNode("span", null, _toDisplayString(_unref(t)(item.key)), 1)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("section", _hoisted_19, [
        _createElementVNode("h3", _hoisted_20, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('出力データ')), 1),
          _createElementVNode("div", {
            ref_key: "tooltipRef",
            ref: tooltipRef,
            class: "inventory-template-page__tooltip-wrapper"
          }, [
            _createVNode(SvgLoader, {
              name: "questionIcon",
              class: "inventory-template-page__help-icon",
              onClick: toggleTooltip
            }),
            (showTooltip.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("p", null, _toDisplayString(_unref(t)('客先内示(N-1)とは、受領月が前月の内示を表示します。')), 1),
                  _createElementVNode("p", null, _toDisplayString(_unref(t)('例: 2025年10月の内示を表示する場合、受領月は2025年9月の内示が表示されます。')), 1),
                  _createElementVNode("p", null, _toDisplayString(_unref(t)('仕入先内示(N-1)とは、作成月が前月の内示を表示します。')), 1)
                ]))
              : _createCommentVNode("", true)
          ], 512)
        ]),
        _createElementVNode("p", _hoisted_22, _toDisplayString(_unref(t)('出力する数値データを選択してください')), 1),
        _createElementVNode("div", _hoisted_23, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(outputDataItems), (item) => {
            return (_openBlock(), _createElementBlock("label", {
              key: item.key,
              class: "inventory-template-page__checkbox-item"
            }, [
              _createElementVNode("input", {
                type: "checkbox",
                checked: item.checked,
                onChange: ($event: any) => (_unref(handleOutputDataItemChange)(item, ($event.target as HTMLInputElement).checked))
              }, null, 40, _hoisted_24),
              _createElementVNode("span", null, _toDisplayString(_unref(t)(item.key)), 1)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("section", _hoisted_25, [
        _createElementVNode("h3", _hoisted_26, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('出力設定')), 1),
          _createVNode(SvgLoader, {
            name: "chevronRight",
            class: "inventory-template-page__arrow-icon"
          })
        ]),
        _createElementVNode("p", _hoisted_27, _toDisplayString(_unref(t)('出力期間と出力形式を選択してください')), 1),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("label", _hoisted_30, _toDisplayString(_unref(t)('出力期間')), 1),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("label", _hoisted_33, _toDisplayString(_unref(t)('開始月')), 1),
                _createVNode(MonthPicker, {
                  "model-value": startYearMonth.value,
                  locale: locale.value,
                  "prop-format": "yyyy / MM",
                  "max-date": endYearMonth.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (startYearMonth.value = $event))
                }, null, 8, ["model-value", "locale", "max-date"])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("label", _hoisted_35, _toDisplayString(_unref(t)('終了月')), 1),
                _createVNode(MonthPicker, {
                  "model-value": endYearMonth.value,
                  locale: locale.value,
                  "prop-format": "yyyy / MM",
                  "min-date": startYearMonth.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (endYearMonth.value = $event))
                }, null, 8, ["model-value", "locale", "min-date"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("label", _hoisted_37, _toDisplayString(_unref(t)('出力形式')), 1),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("label", {
                class: _normalizeClass(["inventory-template-page__radio-item", { 'inventory-template-page__radio-item--selected': outputFormat.value === 'byMonth' }])
              }, [
                _createElementVNode("input", {
                  type: "radio",
                  name: "outputFormat",
                  value: "byMonth",
                  checked: outputFormat.value === 'byMonth',
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (outputFormat.value = 'byMonth'))
                }, null, 40, _hoisted_39),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("span", _hoisted_41, _toDisplayString(_unref(t)('月単位で横並びにまとめる')), 1),
                  _createElementVNode("span", _hoisted_42, _toDisplayString(_unref(t)('例:1月(在庫、販売実績...)→2月(在庫、販売実績...)')), 1)
                ])
              ], 2),
              _createElementVNode("label", {
                class: _normalizeClass(["inventory-template-page__radio-item", { 'inventory-template-page__radio-item--selected': outputFormat.value === 'byDataType' }])
              }, [
                _createElementVNode("input", {
                  type: "radio",
                  name: "outputFormat",
                  value: "byDataType",
                  checked: outputFormat.value === 'byDataType',
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (outputFormat.value = 'byDataType'))
                }, null, 40, _hoisted_43),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("span", _hoisted_45, _toDisplayString(_unref(t)('データ種類単位で横並びにまとめる')), 1),
                  _createElementVNode("span", _hoisted_46, _toDisplayString(_unref(t)('例:在庫(1月、2月...)→販売実績(1月、2月...)')), 1)
                ])
              ], 2)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})